import { client } from "api";

export type DeleteSerialEntityRequest = { productId: string };
export type DeleteSerialEntityResponse = string;

export const deleteSerialEntity = ({ productId }: DeleteSerialEntityRequest) =>
  client
    .delete<DeleteSerialEntityResponse>(`/checklist/serialEntity`, { data: { id: productId } })
    .then((res) => res.data);
